import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { SafePipe } from './common/pipes/safe.pipe';
import { CalendarModule } from 'primeng/calendar';
import { AccordionModule } from 'primeng/accordion';
import { EditorModule } from '@tinymce/tinymce-angular';
import { CheckboxSelectComponent } from './common/components/checkbox-select/checkbox-select.component';
import { ContraventionsQuestionComponent } from './common/components/policies-items/contraventions-question/contraventions-question.component';
import { ExplainQuestionComponent } from './common/components/policies-items/explain-question/explain-question.component';
import { MultipleSelectQuestionComponent } from './common/components/policies-items/multiple-select-question/multiple-select-question.component';
import { RadioQuestionComponent } from './common/components/policies-items/radio-question/radio-question.component';
import { SelectQuestionComponent } from './common/components/policies-items/select-question/select-question.component';
import { LinkifyPipe } from './common/pipes/linkify.pipe';
import { ReportFormatPipe } from './common/pipes/report-format.pipe';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// import { GridModule } from '@progress/kendo-angular-grid';
import { MultiSelectModule } from 'primeng/multiselect';
import { DropdownModule } from 'primeng/dropdown';
//import { Select2Module } from 'ng-select2-component';
 import { Select2Module } from "../../../projects/ng-select2-component/src/public_api";
import { DynamicPopoverDirective } from './common/directives/dynamic-popover.directive';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    CalendarModule,
    AccordionModule,
    NgbModule,
    EditorModule,
    MultiSelectModule,
    DropdownModule,
    BrowserModule,
    FormsModule,
    Select2Module,
  ],
  declarations: [
    LinkifyPipe,
    ReportFormatPipe,
    SafePipe,
    CheckboxSelectComponent,
    ContraventionsQuestionComponent,
    ExplainQuestionComponent,
    MultipleSelectQuestionComponent,
    RadioQuestionComponent,
    SelectQuestionComponent,
    DynamicPopoverDirective,
  ],
  exports: [
    LinkifyPipe,
    ReportFormatPipe,
    CalendarModule,
    AccordionModule,
    SafePipe,
    CheckboxSelectComponent,
    ContraventionsQuestionComponent,
    ExplainQuestionComponent,
    MultipleSelectQuestionComponent,
    RadioQuestionComponent,
    SelectQuestionComponent,
    EditorModule,
    Select2Module,
  ],
})
export class SharedModule {}
